import { FC } from 'react';
import { CgPhone } from 'react-icons/cg';
import { Icon, Text } from '@chakra-ui/react';

import { WorkflowStepFormFieldPhone } from '../types/workflowStepComponentTypes';
import { FieldToBlock, FieldValueProps } from './declarations';
import { commonFieldBlockProps } from './FieldUtils';

export const PhoneFieldToBlock: FieldToBlock<
  'phone',
  WorkflowStepFormFieldPhone
> = (field) => ({
  ...commonFieldBlockProps(field),
  componentType: 'phone',
  componentProps: {
    startElement: <CgPhone />,
    size: 'sm',
  },
});

type PhoneFieldValueProps = FieldValueProps<'phone'>;

export const PhoneFieldValue: FC<PhoneFieldValueProps> = ({ field }) => (
  // @TODO: color needs to be passed somehow, not hardcoded
  // perhaps look at how we pass it to the writable version above and the block builder
  <Text>
    <Icon color="primary.500" fontSize="1.4rem">
      <CgPhone />
    </Icon>
    {field.value}
  </Text>
);
